<template>
  <div id="admin_businesses_missing_items_groups_list">
    <CardedTable :items="items" :headers="headers">
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>


<script>
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
import Utils from '../../../lib/Utils';
export default {
  name: "AdminMissingInfoGroupItems",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => {
    return {
      _user: null,
      items: [],
      headers: [
          {
          text: "Missing",
          align: "start",
          sortable: false,
          value: "missing",
          filterable: true,
        },
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
          filterable: true,
        },
        {
          text: "Description",
          align: "start",
          sortable: false,
          value: "description",
          filterable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  methods: {

    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_admin_missing_info_report(
        {
          user_id: this._user.id,
        },
        (res) => {
            //console.log("res: ", res);
          var items = Utils.scan_businesses_missing_info(
              res.businesses,
              res.hollidays
          );

          var missings = [];
          var groups = [];
          var temp_list = [];
          for (var index = 0; index < items.length; index++) {
            var item = items[index];
            if (missings.indexOf(item.missing) > -1) {
              //already in array, so remove missing and description
              //get the index
              var ind = missings.indexOf(item.missing);
              groups[ind].push({
                business_id: parseInt(item.business_id),
                name: item.name,
                missing: "",
                description: "",
              });
            } else {
              missings.push(item.missing);
              groups.push([item]);
            }
          }
          //now we join all the groups together
          for (var index = 0; index < groups.length; index++) {
              var group = groups[index];
              temp_list =  temp_list.concat(group);
          }
          this.items = temp_list;
          

          this.$emit("on-hide-loader");
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading busineeses on missing info list on admin side of things",
            errors
          );
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/admin/businesses/list/view/" + item.business_id);
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    this.$emit("set-page-attributes", {
      title: "Missing Info List",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Missing",
          disabled: false,
          href: "/admin/missing",
        },
        {
          text: "List",
          disabled: true,
          href: "/admin/missing/info",
        },
      ],
    });
    this.load_items();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#admin_businesses_missing_items_groups_list", options);
  },
};
</script>